import { render, staticRenderFns } from "./StagingArea.vue?vue&type=template&id=50bfb464"
import script from "./StagingArea.vue?vue&type=script&lang=js"
export * from "./StagingArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports